import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface ArcadeIframeOptions {
  embedParams?: string;
  cssText?: string;
  title?: string;
}

const DEFAULT_EMBED_PARAMS = 'embed&embed_mobile=tab&embed_desktop=inline';
const DEFAULT_CSS_TEXT = 'border-width:0;width:100%;height:100%;z-index:1';

@Injectable({ providedIn: 'root' })
export class ArcadeIframeService {
  private document = inject(DOCUMENT);
  private translate = inject(TranslateService);

  createIframe(demoId: string, options?: ArcadeIframeOptions): HTMLIFrameElement {
    const embedParams = options?.embedParams ?? DEFAULT_EMBED_PARAMS;
    const cssText = options?.cssText ?? DEFAULT_CSS_TEXT;
    const title = options?.title ?? this.translate.instant('Interactive product demo');
    const iframe = this.document.createElement('iframe');

    iframe.src = `https://demo.arcade.software/${demoId}?${embedParams}`;
    iframe.style.cssText = cssText;
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('data-arcade-demo-id', demoId);
    iframe.title = title;
    iframe.allowFullscreen = true;
    iframe.setAttribute('allow', 'clipboard-write; fullscreen');

    return iframe;
  }
}
